/**
 * Converts a string to camelCase.
 *
 * Examples:
 * - "hello_world" -> "helloWorld"
 * - "hello-world" -> "helloWorld"
 * - "Hello world" -> "helloWorld"
 * - "APIResponse_value" -> "apiResponseValue"
 */
export function toCamelCase(value: string): string {
  if (!value) return "";

  const words = value
    .normalize("NFKC")
    .trim()
    // Split acronym boundaries: "APIResponse" -> "API Response"
    .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")
    // Split camel boundaries: "helloWorld" -> "hello World"
    .replace(/([a-z\d])([A-Z])/g, "$1 $2")
    // Normalize separators to spaces
    .replace(/[_\-.]+/g, " ")
    .split(/\s+/)
    .filter(Boolean);

  if (words.length === 0) return "";

  return words
    .map((word, index) => {
      const lower = word.toLowerCase();
      return index === 0 ? lower : lower[0].toUpperCase() + lower.slice(1);
    })
    .join("");
}
